<template>
    <Modal v-slot="{ close }">
        <div class="modal__body">
            <div class="form-group">
                <textarea class="form-group__textarea" id="modal-cart-comment" v-model="comment"></textarea>
                <div class="form-group__label" :class="{'form-group__label--focus': comment != ''}">Комментарий</div>
            </div>
            <div class="modal-buttons">
                <button type="button" class="btn modal-buttons__btn" @click="update">Сохранить</button>
            </div>
        </div>
    </Modal>
</template>

<script>
export default {
    name: "modal-comment",
};
</script>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import Modal from '@js/components/ui/modals/modal';

const emits = defineEmits(['close', 'update']);
const props = defineProps({
    index: Number,
    comment: {
        type: [String, Object]
    }
})

const comment = ref(props.comment || '');
const status = ref({
    message: '',
    error: null,
    sending: null,
})

const update = async () => {
    status.value.sending = true;
    status.value.message = '';
    status.value.error = false;

    await axios.post('/cart/item/update-comment', {index: props.index, comment: comment.value})
        .then(response => {
            emits('update', comment.value);
        })
        .catch(error => {
            status.value.error = true;
            status.value.message = error.response?.data.message || error.message;
        })
}

const close = () => {
    emits('close');
}

</script>